import type { CSSProperties } from 'react';
import { avatarColor, initials } from '@/lib/messageModel';
import { channelKind } from '@/lib/channels';

interface Props {
  name: string;
  seed: number;
  channelType?: string;
}

/** Круглый аватар с инициалами и значком канала в углу (как в прототипе). */
export function Avatar({ name, seed, channelType }: Props) {
  const kind = channelType ? channelKind(channelType) : null;
  const Icon = kind?.icon;
  return (
    <span className="av" style={{ background: avatarColor(seed) } as CSSProperties} aria-hidden>
      {initials(name)}
      {kind && Icon && (
        <span className="ch" style={{ background: kind.color } as CSSProperties}>
          <Icon />
        </span>
      )}
    </span>
  );
}
